import { Trans, useTranslation } from 'react-i18next';

type PlanCardProps = {
  id: string;
  title: { i18nKey: string } | string;
  titleColor: string;
  cartHistory: string;
  users: string;
  price: string;
  isDark: boolean;
  buttonAction: React.ReactNode;
  height: string;
};

/**
 * Subscription plan card component
 * @param props - Component properties
 * @returns Subscription plan card
 */
export const PlanCard = ({
  id,
  title,
  titleColor,
  cartHistory,
  users,
  price,
  isDark,
  buttonAction,
  height,
}: PlanCardProps) => {
  const { t, i18n } = useTranslation();

  const i18nLang = i18n.resolvedLanguage
    ? i18n.resolvedLanguage.toLowerCase()
    : i18n.language.toLowerCase();

  const textColor = isDark ? 'text-offWhite' : 'text-primary-dark';
  const labelColor = isDark ? 'text-skyBlue' : 'text-primary-dark';

  return (
    <div
      className={`upgrade-card ${isDark ? 'bg-primary-dark' : ''} ${height}`}
    >
      <h2
        className={`text-center font-primary text-2xl font-bold ${textColor} medLg:text-3xl`}
      >
        {typeof title === 'string' ? (
          <>
            <span className={titleColor}>+</span>
            {title}
          </>
        ) : (
          <Trans
            i18nKey={t(title.i18nKey)}
            components={[<span className={titleColor}></span>]}
          />
        )}
      </h2>

      <div className='flex flex-col items-center justify-center gap-1'>
        <span className={`font-secondary text-base font-normal ${labelColor}`}>
          {t('upgrade.cart_history')}
        </span>
        <span
          className={`font-primary text-lg font-semibold ${textColor} medLg:text-xl`}
        >
          {t(cartHistory)}
        </span>
      </div>

      <div className='flex flex-col items-center justify-center gap-1'>
        <span className={`font-secondary text-base font-normal ${labelColor}`}>
          {t('common.users')}
        </span>
        <span
          className={`font-primary text-lg font-semibold ${textColor} medLg:text-xl`}
        >
          {users}
        </span>
      </div>

      <div
        className={`flex w-full flex-row items-center justify-center gap-x-4 gap-y-6 medLg:mt-auto medLg:flex-col ${i18nLang === 'en' || i18nLang === 'zh' ? '' : 'flex-wrap'}`}
      >
        <div className='flex flex-col items-center justify-center gap-1'>
          <span
            className={`font-primary text-2xl font-bold ${textColor} medLg:text-3xl`}
          >
            ${price}
          </span>
          <span
            className={`font-secondary text-base font-normal ${labelColor}`}
          >
            USD/Month
          </span>
        </div>
        {buttonAction}
      </div>
    </div>
  );
};
